var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTabPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#999999;}\n\t.st4{display:inline;fill:none;stroke:#222222;}\n\t.st5{display:inline;fill:#222222;}\n\t.st6{display:inline;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,20c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S16.4,20,12,20z M12,5c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7 c3.9,0,7-3.1,7-7C19,8.1,15.9,5,12,5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,16.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.8-0.6-1.1-1C9.1,14.5,9,14,9,13.5v-3C9,10,9.1,9.5,9.4,9 c0.2-0.4,0.6-0.8,1.1-1c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.1,0.1,1.6,0.3s0.8,0.5,1.1,0.9c0.2,0.4,0.4,0.9,0.4,1.4c0,0,0,0.1,0,0.1 c0,0-0.1,0-0.1,0l-1.1,0.1c-0.1,0-0.1,0-0.1-0.1c0-0.5-0.1-0.9-0.4-1.1C12.9,9,12.5,8.9,12,8.9c-0.5,0-0.9,0.1-1.2,0.4 c-0.3,0.3-0.4,0.7-0.4,1.1v3.1c0,0.5,0.1,0.8,0.4,1.1s0.7,0.4,1.2,0.4c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.7,0.4-1.1 c0-0.1,0-0.1,0.1-0.1l1.1,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0.5-0.1,1-0.4,1.4c-0.2,0.4-0.6,0.7-1.1,0.9 C13.1,16.2,12.6,16.3,12,16.3z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 12,
    cy: 12,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,16.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.8-0.6-1.1-1C9.1,14.5,9,14,9,13.5v-3C9,10,9.1,9.5,9.4,9 c0.2-0.4,0.6-0.8,1.1-1c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.1,0.1,1.6,0.3s0.8,0.5,1.1,0.9c0.2,0.4,0.4,0.9,0.4,1.4c0,0,0,0.1,0,0.1 c0,0-0.1,0-0.1,0l-1.1,0.1c-0.1,0-0.1,0-0.1-0.1c0-0.5-0.1-0.9-0.4-1.1C12.9,9,12.5,8.9,12,8.9c-0.5,0-0.9,0.1-1.2,0.4 c-0.3,0.3-0.4,0.7-0.4,1.1v3.1c0,0.5,0.1,0.8,0.4,1.1s0.7,0.4,1.2,0.4c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.7,0.4-1.1 c0-0.1,0-0.1,0.1-0.1l1.1,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0.5-0.1,1-0.4,1.4c-0.2,0.4-0.6,0.7-1.1,0.9 C13.1,16.2,12.6,16.3,12,16.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 12,
    cy: 12,
    r: 7.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_3",
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 12,
    cy: 12,
    r: 8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_4",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M12,16.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.8-0.6-1.1-1S9,14,9,13.5v-3C9,10,9.1,9.5,9.4,9s0.6-0.8,1.1-1 c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.1,0.1,1.6,0.3C14,8.3,14.4,8.6,14.6,9S15,9.9,15,10.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0l-1.1,0.1 c-0.1,0-0.1,0-0.1-0.1c0-0.5-0.1-0.9-0.4-1.1C12.9,9,12.5,8.9,12,8.9c-0.5,0-0.9,0.1-1.2,0.4s-0.4,0.7-0.4,1.1v3.1 c0,0.5,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.2,0.4c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.7,0.4-1.1c0-0.1,0-0.1,0.1-0.1l1.1,0 c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0.5-0.1,1-0.4,1.4c-0.2,0.4-0.6,0.7-1.1,0.9S12.6,16.3,12,16.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabPoints);
export default __webpack_public_path__ + "static/media/icon-tab-points.3a20a1ae16fd9ebeaf4a231c7cde3f0b.svg";
export { ForwardRef as ReactComponent };